import { API_URL } from "../../config";
import { getApiToken } from "../../api-token";

const PUZZEL_API = "https://api.puzzel.com/ContactCentre5";

export async function loadPuzzelQueues(token, customerKey, filterIds) {
    try {
        const query = filterIds ? `?filterIds=${filterIds}` : "";
        const url = `${PUZZEL_API}/${customerKey}/visualqueues/stateinformation/All${query}`;
        const response = await fetch(url, {
            headers: {
                "Authorization": `Bearer ${token}`,
            },
        });

        if (response.status !== 200) {
            if (response.status === 401) {
                return [false, null, true, "Unauthorized"];
            }
    
            if (response.status === 403) {
                return [false, null, true, "Forbidden"];
            }

            const error = await response.text();
            return [false, null, false, error];
        }

        const data = await response.json();
        const queues = data.result || [];

        return [true, queues, false, null];
    }
    catch {
        return [false, null, true, "Failed to load puzzel queues"];
    }
}

export async function loadPuzzelQueueUserDetails(token, customerKey, queueId) {
    try {
        const url = `${PUZZEL_API}/${customerKey}/visualqueues/${queueId}/info/UserDetailsOnly`;
        const response = await fetch(url, {
            headers: {
                "Authorization": `Bearer ${token}`,
            },
        });

        if (response.status !== 200) {
            if (response.status === 401) {
                return [false, null, true, "Unauthorized"];
            }
    
            if (response.status === 403) {
                return [false, null, true, "Forbidden"];
            }

            const error = await response.text();
            return [false, null, false, error];
        }

        const data = await response.json();
        return [true, data.result, false, null];
    }
    catch {
        return [false, null, true, "Failed to load puzzel queue info"];
    }
}

export async function loadPuzzelQueueUserOverview(token, customerKey, queueId) {
    try {
        const url = `${PUZZEL_API}/${customerKey}/visualqueues/${queueId}/info/UserOverviewOnly`;
        const response = await fetch(url, {
            headers: {
                "Authorization": `Bearer ${token}`,
            },
        });

        if (response.status !== 200) {
            if (response.status === 401) {
                return [false, null, true, "Unauthorized"];
            }
    
            if (response.status === 403) {
                return [false, null, true, "Forbidden"];
            }

            const error = await response.text();
            return [false, null, false, error];
        }

        const data = await response.json();
        return [true, data.result, false, null];
    }
    catch {
        return [false, null, true, "Failed to load puzzel queue info"];
    }
}

export async function loadPuzzelToken(customerKey) {
    try {
        const [loggedIn, token] = getApiToken();
        if (!loggedIn)
            return [false, null, "Not logged in"];

            const response = await fetch(`${API_URL}/api/puzzel-token/${customerKey}`, {
                method: "GET",
                headers: {
                    "Authorization": token,
                },
            });

            if (response.status !== 200) {
                const error = await response.text();
                return [false, null, error];
            }
    
            const puzzelToken = await response.text();

            return [true, puzzelToken, null]
    }
    catch {
        return [false, null, "Failed to load puzzel token"];
    }
}

export function calcDuration(duration) {
    duration = Number(duration);

    let hours = Math.floor(duration / 3600);
    let minutes = Math.floor(duration % 3600 / 60);
    let seconds = Math.floor(duration % 3600 % 60);

    if (hours < 10) {
        hours = `0${hours}`;
    }
    if (minutes < 10) {
        minutes = `0${minutes}`;
    }
    if (seconds < 10) {
        seconds = `0${seconds}`;
    }
    
    return `${hours}:${minutes}:${seconds}`;
}

export function calcPercent(amount, total) {
    if (total <= 0) 
        return 100;

    if (amount === -1)
        return 100;

    return Math.round((amount / total) * 100);
}